import moment, { Moment } from "moment-timezone";

interface ISaldoBruto {
  data: Moment;
  valorAplicado: number;
  saldoBruto: number;
}

export default class SaldoBruto implements ISaldoBruto {
  public data!: Moment;
  public valorAplicado!: number;
  public saldoBruto!: number;
  constructor(param: ISaldoBruto) {
    Object.assign(this, param);
  }

  public static fromJson(json: ISaldoBrutoJson) {
    return new SaldoBruto({
      ...json,
      data: moment.tz(json.data, "America/Sao_Paulo"),
    });
  }
}

export interface ISaldoBrutoJson extends Omit<ISaldoBruto, "data"> {
  data: Moment;
}
